import React from "react";
import $ from "jquery";
import "datatables.net";

import "../styles/_datatables.scss";

class Table extends React.Component {
  constructor(props) {
    super(props);

    $.extend(true, $.fn.dataTable.defaults, {
      dom:
        "<'row" + props.loadMore
          ? " load-more "
          : "" +
            "no-gutters w-100'<'w-100'tr>>" +
            "<'row justify-content-between align-items-top w-100 ml-0 mr-0'<'col-auto mr-auto p-0'l><'col-auto ml-auto p-0'p>>",
      bInfo: false,
      language: {
        sProcessing: "",
        paginate: {
          previous:
            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48">< g fill="none" fill-rule="evenodd"><path fill="none" d="M0 0h48v48H0z" /><path fill="#000" stroke="#2B2A3A" d="M30.662 39a.666.666 0 0 1-.46-.183L17.057 26.445A3.322 3.322 0 0 1 16 24c0-.936.375-1.804 1.057-2.445L30.202 9.183a.671.671 0 1 1 .92.978L17.978 22.532c-.409.385-.634.907-.634 1.468 0 .562.225 1.083.634 1.468l13.146 12.371a.672.672 0 0 1-.46 1.161" /></g></svg>',
          next: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48">< g fill="none" fill-rule="evenodd"><path fill="none" d="M0 0h48v48H0z" /><path fill="#000" stroke="#2B2A3A" d="M16.671 39a.67.67 0 0 1-.46-1.16l13.145-12.372c.41-.385.634-.906.634-1.468 0-.561-.224-1.083-.634-1.468L16.211 10.161a.672.672 0 1 1 .922-.978l13.144 12.372A3.322 3.322 0 0 1 31.334 24c0 .936-.375 1.805-1.057 2.445L17.133 38.817a.668.668 0 0 1-.462.183" /></g></svg>',
        },
        search: "",
      },
    });
  }

  componentDidMount() {
    $(this.refs.main).dataTable({
      processing: true,
      paging: true,
      ...this.props,
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.data) {
      if (JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
        var dataTable = $(this.refs.main).DataTable();
        dataTable.clear();
        dataTable.rows.add(nextProps.data);
        dataTable.draw();
      }
    }

    return false;
  }

  render() {
    return <table ref="main" />;
  }
}

export default Table;
